<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess(0)" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <!-- {{se_pengeluaran}} -->
            <w-input class="mt4" label="Tarikh Pendaftaran*" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <!-- <template v-if="form.id == 0"> -->
            <br>
            <w-input label="Nombor Batch *" v-model="form.no_batch" :validators="[validators.required]"/>
            <!-- </template> -->
            
            <div class="spacer"></div>
            <br>
            <w-input label="Negara" v-model="form.negara"/>
            <div class="spacer"></div>
            <br>
            <div class="w-flex wrap smd-column" >
               <div class="grow " >
                  <z-select class="mt4" :items="pejantan" label="ID Ternakan Jantan*" @input="pilihNoBatch" v-model="form.se_katalog_id" :validators="[validators.required]"/>
                  <div class="spacer"></div>
                  <br>
                  <w-input label="Nama Ternakan Jantan" v-model="form.nama_ternakan" readonly/>
                  <div class="spacer"></div>
                  <br>
                  <w-input label="Baka Jantan" v-model="form.baka" readonly/>
                  <div class="spacer"></div>
                  <br>
               </div>
            <div class="mx2"></div>
               <div class="grow " >
                  <z-select class="mt4" :items="penderma" label="ID Ternakan Penderma*" @input="pilihInduk" v-model="form.se_katalog_induk_id" :validators="[validators.required]"/>
                  <div class="spacer"></div>
                  <br>
                  <w-input label="Nama Ternakan Penderma" v-model="form.nama_penderma_ternakan" readonly/>
                  <div class="spacer"></div>
                  <br>
                  <w-input label="Baka Penderma" v-model="form.penderma_baka" readonly/>
                  <div class="spacer"></div>
                  <br>
               </div>
            </div>
            <w-input label="Tarikh Pengeluaran" type="date" v-model="form.tarikh_pengeluaran" />
            <div class="spacer"></div>
            <br>
            <w-input label="Generasi" v-model="form.gred" />
            <br>
            <w-input label="Stage" v-model="form.stage" />
            <br>
            <!-- <w-input label="Bilangan Straw Dipungut" type="number" v-model="form.bil_straw"/> -->
            <br>
            <w-input label="Bilangan Straw Didaftarkan*" type="number" v-model="form.baki" :max="form.bil_straw" @keyup="baki()" :validators="[validators.required]"/>
            <z-money class="mt4" label="Harga Perstraw (RM) *" v-model:originalValue="form.harga" :validators="[validators.required]"/>
          </div>
          
        </div>
        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3', '11'])">
         <!-- <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" :loading="form.submitted && !form.sent" v-on="on" @click="send(2); onSuccess()"><div style="width: 6px"></div> 
                    <w-icon dark tile class="mr2" md>fal fa-save</w-icon>
                </w-button>
                </template>
               SIMPAN
            </w-tooltip>
          &nbsp;
          <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" type="submit" v-on="on" bg-color="success" @click="send(1)" :disabled="form.valid === false" :loading="form.submitted && !form.sent"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                </w-button>
                </template>
               HANTAR
            </w-tooltip> -->
            <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
            &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_penderma : [Array, Object],
    d_pejantan : [Array, Object],
  },
  data() {
    return {
      resourceurl: 'embrio.pendaftaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: ' Pendaftaran IBVK', route: '/embrio/pengeluaran' },
      ],
      title : ' Pendaftaran IBVK',
      form : this.d_form,
      pejantan : this.d_pejantan,
      penderma : this.d_penderma,
      
    }
  },
  methods: {
   baki(){
      if(this.form.baki > this.form.bil_straw){
         this.form.baki = this.form.bil_straw;
      }
   },
   pilihNoBatch(value){
      for (var i in this.d_pejantan) {
         if (this.form.se_katalog_id == this.pejantan[i].value) {
            this.form.negara = 'IBVK Malaysia';
            this.form.id_ternakan = this.pejantan[i].id_ternakan;
            this.form.nama_ternakan = this.pejantan[i].nama_ternakan;
            this.form.baka = this.pejantan[i].baka;
         }
      }
      // alert('asd');
   },
   tutup(){
         this.$inertia.visit(window.route('embrio.pendaftaran.index'));
       },
   pilihInduk(){
      for (var i in this.penderma) {
         if (this.form.se_katalog_induk_id == this.penderma[i].value) {
            this.form.nama_penderma_ternakan = this.penderma[i].nama_ternakan;
            this.form.penderma_baka = this.penderma[i].baka;
         }
      }
   },
   send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('embrio.pendaftaran.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('embrio.pendaftaran.show',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('embrio.pendaftaran.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('embrio.pendaftaran.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('embrio.pendaftaran.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },


    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pendaftaran IBVK'
    }
    else
    {
      this.title = 'Tambah Pendaftaran IBVK'
    }
   
    
  }
    
}
</script>
